import React, { useState } from "react";
import cx from "classnames";
import { Waitlist } from "src/components/product/waitlist";
import { Price } from "src/components/price";

import { useAddItemToCart } from "src/context/siteContext";

import styles from "./form.module.css";

export const ProductForm = ({
  className,
  defaultPrice,
  waitlist = true,
  activeLiveVariant,
  activeVariantId,
  available,
  productTrackingObject,
  isPreOrder,
}: {
  className?: string;
  defaultPrice: string;
  waitlist?: boolean | true;
  activeLiveVariant: any;
  activeVariantId: number;
  available: boolean;
  productTrackingObject: {};
  isPreOrder: boolean;
}) => {
  const addItemToCart = useAddItemToCart();
  const [adding, setAdding] = useState(false as boolean);
  const [waitlistOpen, setWaitlistOpen] = useState(false as boolean);

  const toggleWaitlist = () => {
    setWaitlistOpen(!waitlistOpen);
  };

  const form = React.createRef<HTMLFormElement>();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (available) {
      setAdding(true);
      addItemToCart(activeLiveVariant, 1).then(() => {
        // Fire analytics event
        // @ts-ignore
        window.analytics && window.analytics.addToCart(productTrackingObject);

        setAdding(false);
      });
    } else {
      setWaitlistOpen(true);
    }
  };

  return (
    <>
      <form
        className={cx(className, styles.form)}
        onSubmit={(e) => handleSubmit(e)}
        ref={form}
      >
        <button
          type="submit"
          className={cx(
            "cta",
            available ? "cta--primary" : "cta--secondary",
            styles.addToCartButton
          )}
          // disabled={!available}
        >
          <span>
            {}
            {!available && (
              <React.Fragment>
                {isPreOrder
                  ? "Pre-order sign up"
                  : "Notify me when back in stock"}
              </React.Fragment>
            )}
            {available && (
              <React.Fragment>
                {adding ? "Adding..." : "Add to bag"}
                <span className={cx("ml1")}>
                  <Price
                    defaultPrice={defaultPrice}
                    presentmentPrices={activeLiveVariant?.presentmentPrices}
                    variantId={activeVariantId}
                  />
                </span>
              </React.Fragment>
            )}
          </span>
        </button>
      </form>
      <Waitlist
        open={waitlistOpen}
        toggle={toggleWaitlist}
        accountId="Uj8avs"
        message={
          isPreOrder
            ? "You will receive a notification when the product is available."
            : "Got it! We'll update you when it's back in stock."
        }
        buttonText="Submit"
        variantId={activeVariantId}
      />
    </>
  );
};
